import React, { FC } from 'react';
import classNames from 'classnames';
import { useModal } from '../../../../hooks/useModal';
import { MODAL_NAME_CREATE_SYMBOL } from '../../../../constants/modalNamesConstants';
import { SymbolType } from '../fontCreatorTypes';

type PropsType = {
  fontId: number;
  symbols: SymbolType[];
  canGenerateFont: boolean;
};

const SymbolsContainer: FC<PropsType> = ({ fontId, symbols, canGenerateFont }: PropsType) => {
  const { onOpenModal } = useModal(MODAL_NAME_CREATE_SYMBOL);

  return (
    <>
      {symbols.map(({ symbolCode, symbolSVGView }) => {
        const symbol = String.fromCharCode(Number(symbolCode));

        const onClickSymbol = () => {
          if (canGenerateFont) {
            onOpenModal({ symbolCode, fontId });
          }
        };

        let svgUrl = '';
        if (symbolSVGView) {
          const blob = new Blob([symbolSVGView], { type: 'image/svg+xml' });
          svgUrl = URL.createObjectURL(blob);
        }

        const isFilled = !!symbolSVGView;

        return (
          <div
            key={`${symbolCode}-${fontId}`}
            onClick={onClickSymbol}
            className={classNames(
              'relative flex items-center justify-center border w-[90px] min-w-[90px] h-[120px] rounded transition-colors',
              {
                'border-green-300 bg-green-50 cursor-pointer hover:border-green-400': isFilled && canGenerateFont,
                'border-green-200 bg-green-50 cursor-default': isFilled && !canGenerateFont,
                'border-gray-200 hover:border-gray-400 cursor-pointer': !isFilled && canGenerateFont,
                'border-gray-100 cursor-default': !isFilled && !canGenerateFont,
              }
            )}
          >
            <span
              className="absolute inset-0 flex items-center justify-center leading-none opacity-10 font-extralight font-arial select-none"
              style={{ fontSize: '80px', top: '-6px' }}
            >
              {symbol}
            </span>
            {svgUrl && (
              <img
                src={svgUrl}
                alt={symbol}
                className="absolute inset-0 w-full h-full"
                style={{ objectFit: 'fill' }}
              />
            )}
            <div className="h-px w-full absolute bg-primary2 opacity-60" style={{ top: '27px' }} />
            <div className="h-px w-full absolute bg-primary2 opacity-60" style={{ top: '42px' }} />
            <div className="h-px w-full absolute bg-primary2 opacity-60" style={{ top: '84px' }} />
            <span className="absolute bottom-1 left-0 right-0 text-center text-[10px] text-muted-foreground select-none">
              {symbol}
            </span>
          </div>
        );
      })}
    </>
  );
};

export default SymbolsContainer;
